import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import { Button, Message } from "semantic-ui-react";

import FormsInputsText from "../inputs/text/forms_inputs_text";
import FormsInputPassword from "../inputs/password/forms_inputs_password";
import { getErrorMessage } from "../../../utils/api_error";
import LoginSchema from "./validate";

class FormsLogin extends Component {
  state = {
    error: false,
    errorMessage: "",
  };
  renderFormSubmissionResult() {
    // A notice handed down from the OTP step - the challenge expired or ran out
    // of attempts and the admin has been sent back here.
    if (!this.state.error && this.props.notice) {
      return (
        <Message warning style={{ marginTop: "2em" }}>
          {this.props.notice}
        </Message>
      );
    }
    if (this.state.error === true) {
      return (
        <Message negative style={{ marginTop: "2em" }}>
          {this.state.errorMessage}
        </Message>
      );
    }
  }
  render() {
    return (
      <Formik
        initialValues={{ email: "", password: "" }}
        onSubmit={(values, actions) => {
          this.setState({ error: false, errorMessage: "" });
          this.props.doLogin(values, (result, error) => {
            if (error) {
              actions.resetForm();
              actions.setSubmitting(false);
              this.setState({
                error: true,
                errorMessage: getErrorMessage(
                  error,
                  "We're sorry - there was an issue with your credentials."
                ),
              });
              return;
            }
            // Password accepted, but this is not a session yet: hand the
            // challenge up so the page can swap to the OTP step.
            this.props.onOtpRequired(result);
          });
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={LoginSchema}
        render={({
          values,
          errors,
          status,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form>
            <Field
              name="email"
              label=""
              component={FormsInputsText}
              secondaryLabel="Email Address"
            />
            &nbsp;
            <Field
              name="password"
              label=""
              component={FormsInputPassword}
              secondaryLabel="Password"
            />
            &nbsp;
            <Button
              type="submit"
              primary
              disabled={isSubmitting}
              fluid
              loading={isSubmitting}>
              Log In
            </Button>
            <Button
              type="button"
              basic
              fluid
              size="small"
              style={{
                marginTop: "2em",
                marginBottom: "1em",
                padding: 0,
                boxShadow: "none",
              }}
              onClick={() => this.props.history.push("/password/reset")}>
              Reset password
            </Button>
            {this.renderFormSubmissionResult()}
          </Form>
        )}
      />
    );
  }
}

export default FormsLogin;
